import {Component, OnInit, Input, OnChanges, LOCALE_ID} from '@angular/core';
import {WizardWidgetComponent} from '../wizard-widget/wizard-widget.component';
import {SalesService, FormBuilderService, NotificationService} from '../../../services';
import {IndividualQuoteModel} from '../../../models/widgets/quotes-list-model';
import {Router} from '@angular/router';
import {DataHandlerService} from '../../../services/data-handler.service';
import { MatIconModule } from '@angular/material/icon';
import { NgFor, DatePipe } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';

@Component({
    selector: 'app-quotes-list',
    templateUrl: './quotes-list.component.html',
    styles: [],
    providers: [
        { provide: LOCALE_ID, useValue: 'en-AU' },
    ],
    standalone: true,
    imports: [MatCardModule, MatCardModule, FormsModule, ReactiveFormsModule, MatButtonModule, MatButtonModule, MatExpansionModule, NgFor, MatIconModule, DatePipe]
})
export class QuotesListComponent extends WizardWidgetComponent implements OnInit, OnChanges {
  @Input() public broker: any;

  public quotesFormArray: any;
  public pageIndex = 0;
  public disableNext = true;

  private _allQuotes = [];
  private _allPersonalLoans = [
    'purchase-new-personal',
    'purchase-used-personal',
    'refinance-personal',
  ];

  constructor(public dataHandlerService: DataHandlerService,
              private salesService: SalesService,
              private formBuilderService: FormBuilderService,
              private notificationService: NotificationService,
              private router: Router) {
    super(dataHandlerService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.clearQuotes();
  }

  ngOnChanges(changes) {
    this.quotesFormArray = this.formGroup.get('quotesList');

    if (changes['broker'] && changes['broker']['currentValue']) {
      this.populateQuotes();
    }
  }

  public populateQuotes() {
    console.log('[populateQuotes]', this.pageIndex);
    const dateToday = new Date();
    let addedCount = 0;
    this._allQuotes = [];
    this.resetQuotes();

    this.salesService.listQuotes(this.broker.id, this.pageIndex)
      .subscribe((results) => {
        results.forEach((res) => {
          console.log('listQuotes', res);
          addedCount += 1;
          this._allQuotes.push(res);
          this.addQuote(res)
          // if (new Date(res.expiration) >= dateToday) {
          //   addedCount += 1;
          //   this._allQuotes.push(res);
          //   this.addQuote(res);
          // }
        });
        this.checkNext(addedCount);
      });
  }

  public checkNext(addedCount) {
    const dateToday = new Date();
    if (addedCount < 20) {
      this.disableNext = true;
    } else {
      this.salesService.listQuotes(this.broker.id, this.pageIndex + 1)
        .subscribe((results) => {
          if (results.filter(x => new Date(x.expiration) >= dateToday).length === 0) {
            this.disableNext = true;
          } else {
            this.disableNext = false;
          }
        });
    }
  }

  public loadNext() {
    this.pageIndex += 1;
    this.populateQuotes();
  }

  public loadPrev() {
    if (this.pageIndex > 0) {
      this.pageIndex -= 1;
      this.populateQuotes();
    }
  }

  public addQuote(data) {
    const model = new IndividualQuoteModel();
    model.borrower.value = data['data']['app-customer-details']['name'];
    model.createdDate.value = data['created']['when'];

    const fg = this.formBuilderService.convertObjectToFormGroup(model);
    this.formBuilderService.setValidationRules(new IndividualQuoteModel(), fg);
    this.quotesFormArray.push(fg);


  }

  public removeQuote(index) {
    this.quotesFormArray.removeAt(index);
  }

  public deleteQuote(index) {
    const conf = confirm('Are you sure you want to delete this quote?'); // i am being lazy im sorry
    if (conf) {
      this.salesService.deleteQuote(this._allQuotes[index]['_id'])
        .subscribe((result) => {
          this.notificationService.toast('success', 'Quote has been deleted.');
          this.removeQuote(index);
          this._allQuotes.splice(index, 1);
        });
    }
  }

  public resetQuotes() {
    console.log('[resetQuotes]', this.quotesFormArray.controls.length);
    while (this.quotesFormArray.controls.length > 0) {
      this.quotesFormArray.removeAt(0);
    }
  }

  public viewQuote(index) {
    sessionStorage.setItem('quoteId', this._allQuotes[index]['_id']);
    const data = {
      'step-0': this._allQuotes[index]['data']
    };
    sessionStorage.setItem('wiz-online-quote', JSON.stringify(data));
    this.router.navigate(['/application/online-quote']);
  }

  public redirectWizard(index) {
    const data = this.salesService.mapQuoteToApplication(this._allQuotes[index]['data']);
    // console.log('[redirectWizard]', data);

    if (this.checkIfPersonal(this._allQuotes[index]['data']['app-quote-details']['purpose'])) {
      sessionStorage.setItem('wiz-consumer-auto', JSON.stringify(data));
      sessionStorage.setItem('wiz-consumer-auto-step', '0');
      sessionStorage.setItem('wiz-consumer-auto-lead', JSON.stringify(this._allQuotes[index]['lead']));
      this.router.navigate(['/application/consumer-auto']);
    } else {
      sessionStorage.setItem('wiz-business-auto', JSON.stringify(data));
      sessionStorage.setItem('wiz-business-auto-step', '0');
      sessionStorage.setItem('wiz-business-auto-lead', JSON.stringify(this._allQuotes[index]['lead']));
      this.router.navigate(['/application/business-auto']);
    }
  }

  public createQuote() {
    sessionStorage.removeItem('wiz-online-quote');
    sessionStorage.removeItem('quoteId');
    this.router.navigate(['/application/online-quote']);
  }

  public checkIfPersonal(purpose) {
    if (this._allPersonalLoans.includes(purpose)) {
      return true;
    } else {
      return false;
    }
  }

  private clearQuotes() {
    while (this.quotesFormArray.length !== 0) {
      this.quotesFormArray.removeAt(0);
    }
  }
}
